<template>
  <div>
    <div v-if="items.length" class="detail-table-wrap">
      <table class="detail-table alt-table">
        <colgroup>
          <col class="col-chevron" />
          <col class="col-voucher" />
          <col class="col-cliente" />
          <col class="col-chegada" />
          <col class="col-resumo" />
          <col class="col-visto" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Voucher / Reserva</th>
            <th>Cliente</th>
            <th>Chegada</th>
            <th>{{ tipo === "editada" ? "O que mudou" : "Situação" }}</th>
            <th>Visto em</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="i in items">
            <tr
              :key="i.id"
              class="import-row"
              :class="{ 'is-open': openId === i.id }"
              @click="toggle(i.id)"
            >
              <td class="chevron-cell">
                <v-icon
                  size="18"
                  class="chevron"
                  :class="{ 'is-open': openId === i.id }"
                  >mdi-chevron-right</v-icon
                >
              </td>
              <td class="voucher-cell">
                {{ i.voucher }}
              </td>
              <td>{{ i.cliente || "—" }}</td>
              <td class="muted">
                {{ i.chegada ? dataCurta(i.chegada) : "—" }}
              </td>
              <td>
                <span
                  class="rate-pill"
                  :class="
                    tipo === 'editada' ? 'rate-pill--warn' : pillClassCancelada(i)
                  "
                  >{{ resumoLinha(i) }}</span
                >
              </td>
              <td class="muted">{{ i.ultimaVez }}</td>
            </tr>
            <tr
              v-if="openId === i.id"
              :key="i.id + '-det'"
              class="import-detail-row"
            >
              <td colspan="6">
                <div class="alt-panel">
                  <template v-if="tipo === 'cancelada'">
                    <p
                      v-if="statusPhoenixCancelada(i) === 'ativa'"
                      class="alt-note alt-note--bad"
                    >
                      Esta reserva consta como <b>cancelada</b> no portal da
                      CVC, mas <b>ainda está ATIVA no Phoenix</b>
                      <template v-if="codigosAtivos(i).length">
                        (código{{ codigosAtivos(i).length > 1 ? "s" : "" }}:
                        <b>{{ codigosAtivos(i).join(", ") }}</b
                        >)</template
                      >. <b>Alguém precisa cancelá-la manualmente.</b>
                    </p>
                    <p
                      v-else-if="statusPhoenixCancelada(i) === 'ja_cancelada'"
                      class="alt-note alt-note--ok"
                    >
                      Esta reserva consta como <b>cancelada</b> no portal da
                      CVC — e já está <b>cancelada no Phoenix também</b>.
                      Nada a fazer.
                    </p>
                    <p
                      v-else-if="statusPhoenixCancelada(i) === 'nao_existe'"
                      class="alt-note alt-note--ok"
                    >
                      Esta reserva consta como <b>cancelada</b> no portal da
                      CVC.
                      <template v-if="i.naoImportada"
                        ><b>Não foi importada no Phoenix</b> (o agente a
                        retirou do lote).</template
                      >
                      <template v-else
                        ><b>Não existe no Phoenix</b> para este voucher.</template
                      >
                      Nada a fazer.
                    </p>
                    <p v-else class="alt-note">
                      Esta reserva consta como <b>cancelada</b> no portal da
                      CVC. Não foi possível confirmar o status no Phoenix{{
                        i.phoenixErro ? ` (${i.phoenixErro})` : ""
                      }}
                      — confira manualmente.
                    </p>
                  </template>

                  <template v-else-if="Array.isArray(i.diferencas)">
                    <div class="alt-summary">
                      <span class="alt-summary-n">{{ i.diferencas.length }} {{ i.diferencas.length > 1 ? "campos" : "campo" }} a ajustar no Phoenix</span>
                    </div>
                    <table class="alt-cmp">
                      <thead><tr><th>Seção / Campo</th><th class="alt-cmp-phx">Phoenix</th><th class="alt-cmp-cvc">CVC (portal)</th></tr></thead>
                      <tbody><tr v-for="(r, k) in i.diferencas" :key="k" class="is-diff"><td class="alt-cmp-label">{{ r.secao }} — {{ r.campo }} <small v-if="mostrarReserva(i, r)">({{ r.reserva }})</small><span v-if="r.acao === 'preencher'" class="alt-tag">preencher telefone</span><span v-else class="alt-tag">alterar</span></td><td class="alt-cmp-a">{{ r.phoenix || "(em branco)" }}</td><td class="alt-cmp-b">{{ r.portal || "(em branco)" }}</td></tr></tbody>
                    </table>
                  </template>
                  <template v-else-if="i.diferencas === null || (Object.prototype.hasOwnProperty.call(i, 'diferencas') && i.conferido === false)">
                    <p class="alt-note">Não foi possível conferir com o Phoenix nesta execução (reserva não encontrada ou Phoenix indisponível). Confira manualmente.</p>
                  </template>
                  <template v-else>
                    <p class="alt-note">Conferência antiga (pode conter diferenças só de formato).</p>
                    <div class="alt-summary">
                      <span v-if="diffs(i).length" class="alt-summary-n">
                        {{ diffs(i).length }}
                        {{ diffs(i).length > 1 ? "campos" : "campo" }} a alterar
                        no Phoenix
                      </span>
                      <span v-else class="alt-summary-ok">
                        Nenhuma diferença encontrada entre o Phoenix e o portal
                      </span>
                      <a
                        v-if="iguais(i).length"
                        class="alt-toggle"
                        @click.stop="toggleIguais(i.id)"
                      >
                        {{
                          mostrarIguais[i.id]
                            ? "ocultar campos iguais"
                            : `mostrar ${iguais(i).length} campo(s) igual(is)`
                        }}
                      </a>
                    </div>
                    <p v-if="i.phoenixErro" class="alt-note">
                      Não foi possível ler o Phoenix ({{ i.phoenixErro }}).
                    </p>
                    <table class="alt-cmp">
                      <thead>
                        <tr>
                          <th>Campo</th>
                          <th class="alt-cmp-phx">
                            <v-icon size="15" color="#fff"
                              >mdi-database-outline</v-icon
                            >
                            Como está no Phoenix (antes)
                          </th>
                          <th class="alt-cmp-cvc">
                            <v-icon size="15" color="#fff">mdi-pencil</v-icon>
                            Como deve ficar (portal da CVC)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(r, k) in linhasVisiveis(i)">
                          <tr v-if="r.secao" :key="'s' + k" class="alt-cmp-sec">
                            <td colspan="3">{{ r.secao }}</td>
                          </tr>
                          <tr :key="'r' + k" :class="{ 'is-diff': r.diff }">
                            <td class="alt-cmp-label">
                              {{ r.label }}
                              <span v-if="r.diff" class="alt-tag">alterar</span>
                            </td>
                            <td class="alt-cmp-a" :class="{ 'is-empty': !r.a }">
                              {{ r.a || "(em branco)" }}
                            </td>
                            <td class="alt-cmp-b" :class="{ 'is-empty': !r.b }">
                              {{ r.b || "(em branco)" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </template>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot v-if="meta.listadas < meta.total">
          <tr>
            <td colspan="6">
              Listando {{ meta.listadas }} de {{ meta.total }} no período.
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      {{
        tipo === "editada"
          ? "Nenhuma reserva editada no portal da CVC no período."
          : "Nenhuma reserva cancelada no portal da CVC no período."
      }}
    </div>
  </div>
</template>

<script>
const norm = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();

const dataBR = (s) => {
  const m = String(s || "").match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/
  );
  if (!m) return String(s || "");
  return `${m[3]}/${m[2]}/${m[1]}${m[4] && m[4] !== "00:00" ? " " + m[4] : ""}`;
};

// common/models/Reserve.php — unico status que significa "nao esta mais
// ativa" no Phoenix. Qualquer outro valor (rascunho, nao subiu, subiu, em
// execucao, finalizada, solicitada) e' uma reserva de verdade que alguem
// precisa ir cancelar manualmente se o portal da CVC marcou como cancelada.
const RESERVE_STATUS_CANCELED = 2;

export default {
  name: "PortalAlteracoes",
  props: {
    items: { type: Array, default: () => [] },
    meta: { type: Object, default: () => ({ total: 0, listadas: 0 }) },
    tipo: { type: String, required: true }, // 'cancelada' | 'editada'
  },
  data() {
    return { openId: null, mostrarIguais: {} };
  },
  methods: {
    mostrarReserva(i, r) {
      return !!r.reserva && ((i.diferencas || []).some((x) => x.reserva && x.reserva !== r.reserva) || (i.reservasPhoenix || []).length > 1);
    },
    toggleIguais(id) {
      this.$set(this.mostrarIguais, id, !this.mostrarIguais[id]);
    },
    diffs(i) {
      return this.comparacao(i).filter((r) => r.diff);
    },
    iguais(i) {
      return this.comparacao(i).filter((r) => !r.diff);
    },
    // Linhas a mostrar: as que mudam; as iguais so quando pedido. O titulo de
    // secao vai na primeira linha visivel de cada secao.
    linhasVisiveis(i) {
      const todas = this.comparacao(i);
      let secao = null;
      const out = [];
      let ultimaSecaoMostrada = null;
      for (const r of todas) {
        if (r.secao) secao = r.secao;
        if (!r.diff && !this.mostrarIguais[i.id]) continue;
        out.push({
          ...r,
          secao: secao !== ultimaSecaoMostrada ? secao : null,
        });
        ultimaSecaoMostrada = secao;
      }
      return out;
    },
    toggle(id) {
      this.openId = this.openId === id ? null : id;
    },
    dataCurta: dataBR,
    // Classifica o que sabemos do Phoenix pra uma reserva cancelada no portal
    // da CVC: 'ativa' = alguem precisa ir cancelar na mao; 'ja_cancelada' /
    // 'nao_existe' = nada a fazer; 'desconhecido' = a checagem do agente
    // falhou (login/HTTP), nao da pra afirmar nada.
    statusPhoenixCancelada(i) {
      if (i.phoenixErro === "nao_encontrada_no_phoenix") return "nao_existe";
      const reservas = this.phoenixReservas(i);
      if (reservas.length) {
        return reservas.some((r) => r.status !== RESERVE_STATUS_CANCELED)
          ? "ativa"
          : "ja_cancelada";
      }
      return "desconhecido";
    },
    codigosAtivos(i) {
      return this.phoenixReservas(i)
        .filter((r) => r.status !== RESERVE_STATUS_CANCELED)
        .map((r) => r.code)
        .filter(Boolean);
    },
    pillClassCancelada(i) {
      const s = this.statusPhoenixCancelada(i);
      if (s === "ativa") return "rate-pill--bad";
      if (s === "desconhecido") return "rate-pill--warn";
      return "rate-pill--ok";
    },
    resumoLinha(i) {
      if (this.tipo === "cancelada") {
        const s = this.statusPhoenixCancelada(i);
        if (s === "ativa") return "Ainda ativa no Phoenix — cancelar";
        if (s === "ja_cancelada") return "Já cancelada no Phoenix";
        if (s === "nao_existe") return "Não existe no Phoenix";
        return "Não verificado";
      }
      if (Array.isArray(i.diferencas)) return `${i.diferencas.length} campo(s) a ajustar`;
      if (i.diferencas === null || (Object.prototype.hasOwnProperty.call(i, "diferencas") && i.conferido === false)) return "Não conferido";
      if (!Object.prototype.hasOwnProperty.call(i, "diferencas")) return "Conferência antiga";
      const n = i.mudancas.length;
      if (n) return `${n} alteraç${n > 1 ? "ões" : "ão"}`;
      return "Editada no portal";
    },
    comparacao(i) {
      const so = (t) => String(t || "").replace(/\D/g, "");
      const rows = [];
      const add = (secao, label, a, b, tipo) => {
        const x = a || "";
        const y = b || "";
        const igual = tipo === "tel" ? so(x) === so(y) : norm(x) === norm(y);
        rows.push({ secao, label, a: x, b: y, diff: !igual });
      };
      const rs = this.phoenixReservas(i);
      const c = (rs[0] && rs[0].customer) || {};
      const pp = this.portalPassageiros(i);
      add("Cliente", "Nome", c.name, pp[0] || i.cliente);
      add(null, "Telefone", c.phone, i.telefonePortal, "tel");
      const phx = this.phoenixPassageiros(i);
      const nP = Math.max(phx.length, pp.length);
      for (let k = 0; k < nP; k++) {
        add(
          k === 0 ? "Passageiros" : null,
          `Passageiro ${k + 1}`,
          phx[k],
          pp[k]
        );
      }
      const svcs = [];
      for (const r of rs) for (const s of r.services || []) svcs.push(s);
      const vistos = new Set();
      const voosPhx = [];
      for (const s of svcs) {
        const sch =
          s.schedule && s.schedule.trim() !== "-" ? s.schedule.trim() : null;
        if (!sch || vistos.has(sch)) continue;
        vistos.add(sch);
        const data = s.executionDate
          ? dataBR(String(s.executionDate).slice(0, 10))
          : "";
        voosPhx.push(`${sch}${data ? " · " + data : ""}`);
      }
      const n = i.novo || {};
      const voosPortal = (n.voos || []).map(
        (v) =>
          `${v.cia || "?"} - ${v.numero || "?"} · ${v.origem || "?"} → ${
            v.destino || "?"
          } · ${dataBR(v.saida)}`
      );
      const nV = Math.max(voosPhx.length, voosPortal.length);
      for (let k = 0; k < nV; k++) {
        add(k === 0 ? "Voos" : null, `Voo ${k + 1}`, voosPhx[k], voosPortal[k]);
      }
      const hotelPhx = [];
      for (const s of svcs) {
        for (const e of [s.origin, s.destination]) {
          if (e && !/aeroporto/i.test(e) && !hotelPhx.includes(e))
            hotelPhx.push(e);
        }
      }
      const hotelPortal = (n.hoteis || []).map((h) => h.nome).filter(Boolean);
      const nH = Math.max(hotelPhx.length, hotelPortal.length);
      for (let k = 0; k < nH; k++) {
        add(
          k === 0 ? "Hotel" : null,
          `Hotel ${k + 1}`,
          hotelPhx[k],
          hotelPortal[k]
        );
      }
      const entrada = (n.hoteis && n.hoteis[0] && n.hoteis[0].entrada) || null;
      if (entrada || svcs.length) {
        const primeira = svcs
          .map((s) => s.executionDate)
          .filter(Boolean)
          .sort()[0];
        add(
          "Datas",
          "Primeiro serviço / entrada",
          primeira ? dataBR(String(primeira).slice(0, 10)) : "",
          entrada ? dataBR(entrada) : ""
        );
      }
      return rows;
    },
    nomeExiste(nome, lista) {
      const n = norm(nome);
      return lista.some((x) => norm(x) === n);
    },
    phoenixReservas(i) {
      return (i.phoenix && i.phoenix.reserves) || [];
    },
    phoenixPassageiros(i) {
      const out = [];
      for (const r of this.phoenixReservas(i)) {
        for (const p of r.passengers || []) {
          const nome = p.fullName || p.name;
          if (nome && !out.some((x) => norm(x) === norm(nome))) out.push(nome);
        }
      }
      return out;
    },
    phoenixServicos(i) {
      const out = [];
      for (const r of this.phoenixReservas(i)) {
        for (const s of r.services || []) {
          const rota = [s.origin, s.destination].filter(Boolean).join(" → ");
          const detalhe = [
            s.executionDate
              ? dataBR(String(s.executionDate).slice(0, 10))
              : null,
            rota || null,
            s.schedule && s.schedule.trim() !== "-" ? s.schedule : null,
          ]
            .filter(Boolean)
            .join(" · ");
          out.push({ titulo: s.name || "Serviço", detalhe });
        }
      }
      return out;
    },
    portalPassageiros(i) {
      return ((i.novo && i.novo.passageiros) || [])
        .map((p) => p.nome)
        .filter(Boolean);
    },
    portalServicos(i) {
      const n = i.novo;
      if (!n) return [];
      const out = [];
      for (const v of n.voos || []) {
        out.push({
          titulo: `Voo ${v.cia || "?"} ${v.numero || "?"}`,
          detalhe: `${v.origem || "?"} → ${v.destino || "?"} · ${dataBR(
            v.saida
          )}`,
        });
      }
      for (const h of n.hoteis || []) {
        out.push({
          titulo: "Hotel",
          detalhe: `${h.nome || "?"}${
            h.entrada ? " · entrada " + dataBR(h.entrada) : ""
          }`,
        });
      }
      for (const f of n.fornecedores || []) {
        out.push({
          titulo: f.servico || f.nome || "Serviço",
          detalhe: `${dataBR(f.inicio)}${f.fim ? " → " + dataBR(f.fim) : ""}`,
        });
      }
      return out;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.alt-table {
  table-layout: fixed;
  width: 100%;
  min-width: 860px;

  col.col-chevron {
    width: 40px;
  }
  col.col-voucher {
    width: 22%;
  }
  col.col-cliente {
    width: 22%;
  }
  col.col-chegada {
    width: 14%;
  }
  col.col-resumo {
    width: 22%;
  }
  col.col-visto {
    width: 20%;
  }

  th,
  td {
    white-space: normal;
    vertical-align: top;
    word-break: break-word;
  }

  .voucher-cell {
    font-weight: 700;
    color: #384049;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
}

.import-row {
  cursor: pointer;
  &:hover td {
    background: #f3f6f7;
  }
  &.is-open td {
    background: #f4f9f8 !important;
  }
}
.chevron-cell {
  padding-right: 0;
  padding-left: 12px;
}
.chevron {
  transition: transform 0.15s ease;
  color: #9aa2ab;
  &.is-open {
    transform: rotate(90deg);
    color: #0f7a6e;
  }
}
.import-detail-row td {
  padding: 10px 14px 16px 48px;
  background: #f4f9f8;
}

.alt-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.alt-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.alt-chip {
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 20px;
  padding: 3px 11px;
  font-size: 0.76rem;
  color: #4a535c;
}
.alt-block-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b747d;
  margin-top: 4px;
}
.alt-note {
  font-size: 0.82rem;
  color: #4a535c;
  margin: 0;
  background: #fff;
  border: 1px dashed #d6dbe0;
  border-radius: 8px;
  padding: 9px 12px;
  &--bad {
    border-color: #f0b8b8;
    background: #fdf3f3;
    color: #8a2a2a;
  }
  &--ok {
    border-color: #cdeae4;
    background: #eefaf7;
    color: #0f7a6e;
  }
}
.alt-diff {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 8px;
  font-size: 0.8rem;
  th,
  td {
    padding: 7px 10px;
    text-align: left;
    vertical-align: top;
    white-space: normal;
  }
  thead th {
    font-size: 0.7rem;
    text-transform: uppercase;
    color: #6b747d;
    background: #f7f9fa;
  }
  tbody tr + tr td {
    border-top: 1px solid #eef0f2;
  }
}
.alt-old {
  color: #a23a3a;
  background: #fdf3f3;
  text-decoration: line-through;
  text-decoration-color: #e2b0b0;
}
.alt-new {
  color: #17603b;
  background: #eef8f1;
  font-weight: 600;
}

.alt-cmp {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.8rem;
  th {
    padding: 8px 12px;
    text-align: left;
    color: #fff;
    font-size: 0.78rem;
    width: 38%;
  }
  th:first-child {
    width: 24%;
    background: #f7f9fa;
  }
  .alt-cmp-phx {
    background: #0f7a6e;
  }
  .alt-cmp-cvc {
    background: #2f5fa7;
  }
  td {
    padding: 7px 12px;
    vertical-align: top;
    border-top: 1px solid #eef0f2;
    color: #2b333b;
    word-break: break-word;
  }
  .alt-cmp-label {
    color: #6b747d;
    font-size: 0.76rem;
  }
  .alt-cmp-sec td {
    background: #f7f9fa;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #8a939c;
    padding: 5px 12px;
  }
  tr.is-diff td.alt-cmp-a {
    background: #fdf3f3;
    color: #a23a3a;
    text-decoration: line-through;
    text-decoration-color: #e2b0b0;
  }
  tr.is-diff td.alt-cmp-b {
    background: #eef8f1;
    color: #17603b;
    font-weight: 700;
  }
  tr.is-diff td.is-empty {
    text-decoration: none;
  }
  td.is-empty {
    color: #b3bac1;
    font-weight: 400 !important;
  }
}
.alt-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.82rem;
}
.alt-summary-n {
  background: #fff6dc;
  border: 1px solid #f0d58a;
  color: #7a5a00;
  font-weight: 700;
  border-radius: 20px;
  padding: 3px 12px;
}
.alt-summary-ok {
  color: #17603b;
  font-weight: 600;
}
.alt-toggle {
  color: #2f5fa7;
  cursor: pointer;
  font-size: 0.78rem;
  text-decoration: underline;
}
.alt-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 7px;
  border-radius: 10px;
  background: #f0b429;
  color: #3d2c00;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.alt-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.alt-col {
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  padding: 0 0 10px;
  overflow: hidden;
}
.alt-col-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 8px 12px;
  color: #fff;
  &--phx {
    background: #0f7a6e;
  }
  &--cvc {
    background: #2f5fa7;
  }
}
.alt-sec {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8a939c;
  padding: 10px 12px 3px;
}
.alt-list {
  list-style: none;
  margin: 0;
  padding: 0 12px;
  font-size: 0.8rem;
  color: #384049;
  li {
    padding: 2px 0;
  }
  li.is-diff {
    background: #fff6dc;
    border-left: 3px solid #f0b429;
    padding-left: 7px;
    font-weight: 600;
  }
}
.alt-item {
  font-size: 0.72rem;
}
.alt-svc {
  display: flex;
  flex-direction: column;
  padding: 6px 0 !important;
  border-bottom: 1px solid #eef0f2;
  b {
    font-weight: 700;
    color: #2b333b;
  }
  span {
    font-size: 0.76rem;
    color: #6b747d;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.alt-foot {
  font-size: 0.72rem;
  color: #8a939c;
  margin: 0;
}

@media (max-width: 900px) {
  .alt-compare {
    grid-template-columns: 1fr;
  }
}
</style>
